<template>
    <div class="card">
        <div class="card__header">
			<h5 class="card__title">Список лидеров</h5>
        </div>
		<div>
			<div class="table-wrap">
				<table class="table">
					<thead>
					<tr>
						<th>#</th>
						<th>Игрок</th>
						<th>Выигрыш</th>
						<th>Выиграно в Казино</th>
						<th>Выиграно в Режимах</th>
					</tr>
					</thead>
					<tbody>
					<tr v-for="(user, index) in users" :class="{'table--success': user && user.id == user.id }">
						<td>{{ index + 1 }}</td>
						<td>{{ user.username }}</td>
						<td>{{ user.total }} ₽</td>
						<td>{{ user.casino }} ₽</td>
						<td>{{ user.games }} ₽</td>
					</tr>
					</tbody>
				</table>
			</div>
		</div>
    </div>
</template>

<script>
	import { mapState } from 'pinia';
	import { useUserStore } from '../../stores/User';

    export default {
        data() {
            return {
                users: []
            }
        },
		computed: {
			...mapState(useUserStore, ['user'])
		},
        methods: {
            fillTable() {
                this.$root.axios.get('/api/user/stats')
                    .then(res => {
                        const data = res.data;
                        this.users = data.users;
                    });
            },
        },
        beforeMount() {
            this.fillTable()
        }
    }
</script>
